// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lrFY","col":"styles_col__M7OgW"};